

<div class="financial_tab_content">
    <div>
        <h5>Income Statement</h5>
        <app-income-statement [chartKey]="chartKey"></app-income-statement>
    </div>

    <div class="mt-5">
        <h5>Balance Sheet</h5>
        <app-balancesheet [chartKey]="chartKey"></app-balancesheet>
    </div>

    <div class="mt-5">
        <h5>Cashflow</h5>
        <app-f-cashflow [chartKey]="chartKey"></app-f-cashflow>
    </div>

</div>
